const Pages = {
  'Home': '/',
  'About': '/about',
  'Services': '/services',
  'Team': '/team',
  'Individual': {
    'Terry Grainger': '/team/terry-grainger',
    'Ingrid de Chélard': '/team/ingrid-de-chélard',
    'Tee Duong': '/team/tee-duong',
    'Matthew Grainger': '/team/matthew-grainger'
  },
  'Contact': '/contact',
}

export default Pages;